import { connect } from 'react-redux'
import RiderRecentTrips from '../../components/trips/RiderRecentTrips'
import * as actions from '../../state/actions/trips'
import { actionCreators as mapsActionCreators } from '../../state/actions/google_map'
import { IStoreState, IRiderTrip } from '../../types'
import { TRIP_RIDERS_DEFAULT_VALUE } from 'src/utils/group-rider'
import history from 'src/history'
import moment from 'moment'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const riderId = ownProps.match.params.riderId
  return {
    isFetching: state.trips.isFetching,
    riderId,
    recentTrips: state.trips.recentTrips[riderId],
    currentOrganizationId: state.organizations.currentOrgId
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getRecentTrips: (riderId: string, organizationId: string) =>
      dispatch(actions.recentTripsFetch(riderId, organizationId)),
    cloneTrip: async (trip: IRiderTrip) => {
      let destinations
      try {
        const fetchedTrip = await dispatch(actions.getTripById(trip.id))
        destinations = fetchedTrip.destinations
      } catch (e) {
        destinations = []
        console.error('Failed to fetch trip details: ', e)
      }

      const tripClone = { ...trip }
      const pickup = {
        lat: tripClone.pickupLocation.latitude,
        lng: tripClone.pickupLocation.longitude,
        address: tripClone.pickupLocation.fullAddress,
        placeName: tripClone.pickupLocation.placeName
      }
      const dropoff = {
        lat: tripClone.dropoffLocation.latitude,
        lng: tripClone.dropoffLocation.longitude,
        address: tripClone.dropoffLocation.fullAddress,
        placeName: tripClone.dropoffLocation.placeName
      }
      tripClone.product = { id: '', name: '', pricingId: '' }
      tripClone.scheduledPickupTime = moment().toISOString()
      tripClone.scheduledDropoffTime = undefined
      tripClone.confirmationNumber = undefined
      tripClone.providerOneNumber = undefined
      tripClone.destinations = destinations

      await Promise.all([
        dispatch(actions.actionCreators.cloneTrip(tripClone)),
        dispatch(mapsActionCreators.setOrigin(pickup)),
        dispatch(mapsActionCreators.setDestination(dropoff)),
        dispatch(
          mapsActionCreators.replaceMarkers('origin', [
            {
              type: 'origin',
              lat: pickup.lat,
              lng: pickup.lng
            }
          ])
        ),
        dispatch(
          mapsActionCreators.replaceMarkers('destination', [
            {
              type: 'destination',
              lat: dropoff.lat,
              lng: dropoff.lng
            }
          ])
        )
      ])

      const riderId = trip.rider ? trip.rider.riderId : ''

      history.push(`/trips/create/${riderId}`)
    },
    resetTripRiders: () => {
      dispatch(actions.actionCreators.setTripPassengerDetails(TRIP_RIDERS_DEFAULT_VALUE))
      dispatch(actions.actionCreators.updateRiderCount(1))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RiderRecentTrips)



// WEBPACK FOOTER //
// ./src/containers/trips/RiderRecentTrips.ts